<template>
  <div class="container">
    
      <div class="columns is-variable">
        <div class="column">
          <div v-if="context ==='home'">
            <h2>Contact us</h2>
            <div class="level"></div>
            <p>Say hello!</p>
            <div class="level"></div>
            <div class="level"></div>
          </div>
          <div class="columns" v-if="context !=='home'">
            <div class="column is-three-quarters">
            <h2>Work so hot we don't have the permits to show you on our site.</h2>
          </div>
        </div>
        <form name="contact" method="POST" data-netlify="true">
          <div class="columns">
            <div class="column is-one-third">
              <b-field>
                <b-input name="name" placeholder="name"></b-input>
              </b-field>
              <b-field>
                <b-input type="email" name="email" placeholder="email"></b-input>
              </b-field>
              <input type="hidden" name="context" :value="context">
              <input type="hidden" name="form-name" value="contact">
            </div>
            <div class="column is-two-thirds" v-if="context === 'home'">
              <b-field>
                <textarea name="message" class="textarea" type="text" placeholder="message" rows="3" style="height:112px"></textarea>
              </b-field>
            </div>
          </div>
          <div class="columns" v-if="context === 'home'">
            <div class="column is-one-half has-text-right-tablet">
              <button class="button is-primary is-outlined is-fullwidth is-hidden-tablet">Send</button>
              <button class="button is-primary is-outlined is-hidden-mobile">Send</button>
            </div>
          </div>
          <div v-if="context !== 'home'">
            <div class="columns">
              <div class="column is-half">
                <button class="button is-primary is-outlined is-fullwidth-mobile-only" type="submit">Request Case Study</button>
                <div class="level"></div>
              </div>
            </div>
            <h5></h5>
          </div>
          </form>
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  name: 'ContactForm',
  props: ['context'],
  data() {
    return {
      isModalActive: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .button.is-info.is-inverted.is-outlined:hover, .button.is-info.is-inverted.is-outlined:focus {
    color: black;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue